import { render, staticRenderFns } from "./v-image.vue?vue&type=template&id=75af6499&"
import script from "./v-image.vue?vue&type=script&lang=js&"
export * from "./v-image.vue?vue&type=script&lang=js&"
import style0 from "./v-image.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports